module.exports = __webpack_public_path__ + "img/ahorro_kuspit.d14665c5.svg";